<template>
  <div class="eventsDetails">
    <div class="title">
      <span>当前位置：&nbsp;</span>
      <span>展会</span>
      <span>></span>
      <span>会议论坛</span>
      <span style="margin: 0 9px">></span>
      <span @click="backEvents">论坛资讯</span>
      <span style="margin: 0 9px">></span>
      <span>论坛资讯详情</span>
    </div>
    <div class="content">
      <div class="content_top">
        <p class="content_top_title">{{ title }}</p>
        <p class="content_top_content">
          <span>{{ uploadDate ? uploadDate : createDate }}</span>
          <span>
            围观
            <b>{{ watchs }}</b
            >次
          </span>
        </p>
      </div>
      <div class="content_center" v-html="content"></div>
      <div class="content_bottom">
        <div class="pre_next">
          <div class="pre">
            <p></p>
            <p>上一条</p>
            <p @click="preNew">
              {{ preTitle.title }}
              <span style="margin-left: 9px">>></span>
            </p>
          </div>
          <div class="next">
            <p></p>
            <p>下一条</p>
            <p @click="nextNew">
              {{ nextTitle.title }}
              <span style="margin-left: 9px">>></span>
            </p>
          </div>
        </div>

        <p class="zanTopLine"></p>
        <div class="zan">
          <div class="zan_left">
            <img src="../../assets/image/weixin.png" alt />
            <img src="../../assets/image/weibo.png" alt />
          </div>
          <div
            class="zan_center"
            :class="{ fabulousBack: fabulous_click }"
            @click="fabulousClick"
          >
            <img src="../../assets/image/zan.png" alt />
            <p class="num">{{ fabulous }}</p>
            <p>赞</p>
          </div>
          <div class="zan_right">
            <!-- 收藏
            <p></p> -->
          </div>
        </div>

        <div class="tj">
          <div class="line_industry">
            <span>相关新闻</span>
            <span class="line"></span>
          </div>
          <ul>
            <li>
              <p>
                教育装备企业云访谈&nbsp;|&nbsp;迪声音响&nbsp;&nbsp;顺势而为&nbsp;&nbsp;强力抗“疫”
              </p>
            </li>
            <li>
              <p>
                教育装备企业云访谈&nbsp;|&nbsp;迪声音响&nbsp;&nbsp;顺势而为&nbsp;&nbsp;强力抗“疫”
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "",
      watchs: 0,
      createDate: "",
      content: "",
      preTitle: [],
      nextTitle: [],
      imgSrc: "",
      uploadDate: "",
      fabulous: null,
      fabulous_click: null,
    };
  },
  created() {
    this.getInformationList();
  },
  mounted() {
    let queryEventId = this.$route.query.id;
    if (queryEventId) {
      this.getEventInformationDetail(queryEventId);
    }
    let tokenStatus = this.$cookie.get("gzToken");
    if (tokenStatus) {
      let data = this.tokenRules(tokenStatus, 0, this.routeQuery.code*1, "5");
      if (data) {
        data.then((response) => {
          if (response.fabulousCollection === true) {
            this.fabulous_click = true;
          }
        });
      }
    }
  },
  methods: {
    // 当前资讯信息
    getEventInformationDetail(currentId) {
      this.$http({
        url: "informationInfo",
        method: "post",
        params: {
          id: currentId,
        },
      }).then(({ data }) => {
        let { code, information } = data;
        if (code === 0) {
          this.title = information.title;
          this.content = information.content;
          this.watchs = information.watchs;
          this.imgSrc = information.image;
          this.fabulous = information.fabulous;
          this.createDate = information.createDate.substring(0, 10);
          this.uploadDate = information.uploadDate
            ? information.uploadDate.substring(0, 10)
            : "";
          this.preInformation(currentId);
        }
      });
    },
    // 或取所有的论坛资讯
    getInformationList() {
      this.$http({
        url: "getInformationList",
        method: "post",
        params: {
          type: "3",
        },
      }).then(({ data }) => {
        let { code, informationByTypeList } = data;
        if (code === 0) {
          this.totalPage = informationByTypeList.length;
          informationByTypeList.forEach((res) => {
            res.createDate = res.createDate.substring(0, 10);
            res.uploadDate = res.uploadDate
              ? res.uploadDate.substring(0, 10)
              : "";
          });
          this.informationTypeList = informationByTypeList;
        }
      });
    },

    // 点赞
    fabulousClick() {
      var gztk = this.$cookie.get("gzToken");
      if (gztk) {
        this.fabulousFunction();
      } else {
        this.$router.push({
          path: "/audLogin",
        });
      }
    },
    fabulousFunction() {
      this.$http({
        url: "viewer/informationFabulous",
        method: "post",
        params: {
          zhType: "5",
          zhId: this.eventId,
        },
      }).then(({ data }) => {
        if (data.code === 0) {
          this.fabulous_click = !this.fabulous_click;
          this.fabulous = data.fabulous;
        }
      });
    },

    // 当前资讯的index
    preInformation(currentId) {
      let typeLits = this.informationTypeList;
      let eventInfoIndex = (typeLits || []).findIndex(
        (item) => item.id === currentId
      );
      let preInfoObj = typeLits[eventInfoIndex - 1]
        ? typeLits[eventInfoIndex - 1]
        : typeLits[typeLits.length - 1];
      this.preTitle = preInfoObj;
      let nextInfoObj = typeLits[eventInfoIndex + 1]
        ? typeLits[eventInfoIndex + 1]
        : typeLits[0];
      this.nextTitle = nextInfoObj;
    },

    // 上一条新闻
    preNew() {
      this.getEventInformationDetail(this.preTitle.id);
      this.preInformation(this.preTitle.id);
    },
    // 下一条新闻
    nextNew() {
      this.getEventInformationDetail(this.nextTitle.id);
      this.preInformation(this.nextTitle.id);
    },

    backEvents() {
      this.$emit("setEventId");
      this.$emit("getInformationList");
    },
  },
};
</script>>
<style lang="scss" scoped>
.eventsDetails {
  min-height: 1510px;
  background-color: #ffffff;
  box-shadow: -8px 0px 8px #fafafa, 0px -8px 8px #fafafa, 0px 8px 8px #fafafa;
  margin-bottom: 45px;
  padding-bottom: 1px;
  .title {
    height: 43px;
    border-bottom: 1px solid #e5e5e5;
    line-height: 43px;
    padding-left: 17px;
    color: #b6b6b6;
    font-size: 12px;
    span:nth-child(3),
    span:nth-child(5) {
      margin: 0 11px;
    }
    span:nth-child(6) {
      cursor: pointer;
    }
  }
  .content {
    width: 857px;
    min-height: 892px;
    margin: 50px auto 63px;
    .content_top {
      height: 83px;
      border-bottom: 1px solid #dfe1e1;
      position: relative;
      .content_top_title {
        padding: 0 24px 0 10px;
        line-height: 45px;
        font-size: 28px;
        text-align: center;
      }
      .content_top_content {
        width: 200px;
        position: absolute;
        text-align: right;
        font-size: 12px;
        color: #bbbbbb;
        right: 0;
        bottom: 5px;
        span:first-child {
          margin-right: 23px;
        }
        // margin-top: -23px;
      }
    }
    .content_center {
      min-height: 760px;
      overflow: hidden;
      margin-top: 50px;
    }
    .backImg {
      width: 531px;
      height: 320px;
      margin: 50px auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .content_bottom {
      margin-top: 30px;
      .pre_next {
        height: 60px;
        margin-bottom: 56px;
        position: relative;
        .pre {
          float: left;
        }
        .next {
          float: right;
        }
        .pre,
        .next {
          width: 400px;
          height: 60px;
          background-color: #f2f2f2;
          font-size: 12px;
          p:first-child {
            position: absolute;
            width: 4px;
            height: 60px;
            background-color: #d71b1c;
          }
          p:nth-child(2) {
            color: #919191;
            margin: 8px 0 8px 21px;
          }
          p:last-child {
            width: 328px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            margin-left: 21px;
            color: #1879c0;
            border-bottom: 1px solid #1879c0;
            cursor: pointer;
          }
        }
      }
      // .zanTopLine {
      //   width: 936px;
      //   height: 1px;
      //   background-color: #dfe1e1;
      //   margin-left: -39px;
      // }
      // .zan {
      //   height: 214px;
      //   display: flex;
      //   justify-content: space-between;
      //   align-items: center;
      //   .zan_left {
      //     // float: left;
      //     // margin: 63px 276px 0 38px;
      //     img:first-child {
      //       margin-right: 8px;
      //     }
      //   }
      //   .zan_center {
      //     // float: left;
      //     width: 186px;
      //     height: 66px;
      //     background-color: #898989;
      //     border-radius: 50px;
      //     line-height: 186px;
      //     // margin-top: 51px;
      //     cursor: pointer;
      //     img {
      //       float: left;
      //       margin: 20px 0 0 32px;
      //     }
      //     p {
      //       float: right;
      //       height: 66px;
      //       line-height: 71px;
      //     }
      //     .num {
      //       font-size: 14px;
      //       color: #ababab;
      //       margin: 0 30px 0 55px;
      //     }
      //     p:last-child {
      //       color: #ffffff;
      //       font-size: 18px;
      //     }
      //   }
      //   .fabulousBack {
      //     background-color: #143277;
      //   }
      //   .zan_right {
      //     width: 116px;
      //     height: 36px;
      //     // border: 1px solid #8c8c8c;
      //     color: #8c8c8c;
      //     font-size: 15px;
      //     // float: right;
      //     // margin-top: 63px;
      //     border-radius: 20px;
      //     text-align: center;
      //     line-height: 36px;
      //     p {
      //     }
      //   }
      // }
      .tj {
        height: 120px;
        border-bottom: 1px solid #dfe1e1;
        .line_industry {
          height: 20px;
          color: #333333;
          .line {
            display: block;
            float: right;
            width: 785px;
            height: 1px;
            background-color: #dfe1e1;
            margin-top: 11px;
          }
        }
        ul {
          li {
            width: 311px;
            cursor: pointer;
            list-style: square;
            font-size: 12px;
            margin-top: 20px;
            margin-left: 21px;
            border-bottom: 1px solid #1879c0;
            p {
              color: #1879c0;
            }
          }
        }
      }
    }
  }
}
</style>